<template>
  <v-btn
    x-small
    :color="
      $store.getters.getConf.theme_dark ? 'grey darken-4' : 'grey lighten-1'
    "
    dark
    outlined
    @click.prevent="themeDarkAction"
  >
    Modo: {{ $store.getters.getConf.theme_dark ? "Obscuro" : "Claro" }}
  </v-btn>
</template>

<script>
export default {
  props: ["small"],
  data: () => ({
    color: null,
    msg: null,
    visible: false,
  }),
  methods: {
    themeDarkHandle() {
      this.$vuetify.theme.dark = !this.$store.getters.getConf.theme_dark;
    },
    themeDarkAction() {
      this.$store.dispatch("themeDarkAction");
      this.themeDarkHandle();
    },
  },
  mounted() {
    this.themeDarkHandle();
  },
};
</script>
